if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.isFbt = this.form.hasAttribute('data-fbt') && this.form.getAttribute('data-fbt').toLowerCase() === 'true';
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.submitButton = this.querySelector('[type="submit"]');
        this.removeButton = this.querySelector('[type="button"]');
        this.headerCartCounter = document.querySelector('#header-cart-counter');
        this.cartItemCount = this.headerCartCounter.querySelector('.cart-item-count');

        this.removeButton.addEventListener('click', (evt) => {
          evt.preventDefault();

          fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: this.querySelector('input[name="id"]').value,
              quantity: 0
            })
          })
            .then((response) => response.json())
            .then((response) => {
              this.querySelector('button[type="submit"]').classList.remove('button--hide');
              this.querySelector('button[type="button"]').classList.add('button--hide');

              // Update cart counter
              if (this.cartItemCount && this.cartItemCount.textContent) {
                const currentCount = parseInt(this.cartItemCount.textContent, 10);
                if (currentCount > 0) {
                  const newCount = currentCount - 1;
                  this.cartItemCount.textContent = newCount;
                  const cartLink = document.querySelector('#cart-icon-bubble');
                  if (cartLink) {
                    cartLink.setAttribute('aria-label', newCount === 1 ? `${newCount} item` : `${newCount} items`);
                  }
                }
              }
            })
            .catch((e) => {
              console.error(e);
            });
        });

        if (document.querySelector('cart-drawer') || document.querySelector('cart-flyout')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      getCart() {
        if (window.NEWTON_CART_FLYOUT_ENABLED && document.querySelector('cart-flyout')) {
          return document.querySelector('cart-flyout');
        }
        return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        // if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.cart = this.getCart();
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.remove('hidden');

        const hiddenInputs = this.form.querySelectorAll('input[type="hidden"]');
        let productForm = {};
        hiddenInputs.forEach(function(input) {
          productForm[input.name] = input.value;
        });

        let formData = {
          'items': []
        };


        const productIdArray = typeof productForm['id'] === 'string' ? productForm['id'].split(',') : [];

        if (productIdArray.length > 1) {
          // If the string has a comma, create a new object for each value
          productIdArray.forEach(productId => {
            formData.items.push({
              id: productId.trim(),
              'product-id': productForm['product-id'].trim(),
              'quantity': 1
            });
          });
        } else {
          // If the string doesn't have a comma, add the original object
          const productInfoElement = document.querySelector('product-info > h1');
          const bundleProductName = productInfoElement ? productInfoElement.textContent.trim() : 'Unknown Product';
          if( bundleProductName === 'Newton Gift Card' && document.querySelector('input[name="properties[__shopify_send_gift_card_to_recipient]"]:checked')) {
            formData.items.push({
              id: productForm['id'] ? productForm['id'].trim() : '',
              quantity: 1,
              properties: {
                __shopify_send_gift_card_to_recipient: 'on',
                'Recipient email': document.querySelector('input[name="properties[Recipient email]"]').value,
                'Recipient name': document.querySelector('input[name="properties[Recipient name]"]').value,
                'Message': document.querySelector('textarea[name="properties[Message]"]').value,
                'Send on': document.querySelector('input[name="properties[Send on]"]').value,
                '__shopify_offset': document.querySelector('input[name="properties[__shopify_offset]"]').value,
                '_gift_card': `added from ${bundleProductName} page`
              }
            });
          } else {
            if (productForm['id'] || productForm['product-id']) {
              formData.items.push({
              id: productForm['id'] ? productForm['id'].trim() : productForm['product-id'],
              quantity: 1,
              properties: {
                '_added_from_page': productForm['_added_from_page'] ? productForm['_added_from_page'] : `added from ${bundleProductName} page`
              }
              });
            } else {
              console.error('Error: Missing product ID or product-id in productForm.');
              return false;
            }
          }
        }

        if (this.cart) {
          let sectionIds = this.cart.getSectionsToRender().map((section) => section.id);
          formData.sections = sectionIds.join(',');
          formData.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        if ( document.querySelector('input[name="bundle"]:checked') && document.querySelector('input[name="bundle"]:checked').id !== 'no-bundle' ) {
          const selectedProductStyle = document.querySelector('input[name="bundle-option"]:checked');
          const selectedProductStyleId = selectedProductStyle.nextElementSibling.value;
          const bundleProductName = document.querySelector('product-info > h1').textContent.trim();
          formData.items.push({
            id: selectedProductStyleId,
            quantity: 1,
            properties: {
              '_added_from_page': `added from ${bundleProductName} page`
            }
          });
        }

        if ( document.querySelector('input[name="bundle-product-single"]:checked') ) {
          const bundleProductIds = document.querySelectorAll('input[name="bundle-product-single"]:checked');
          bundleProductIds.forEach(bundleProduct => {
          const bundleProductId = bundleProduct.value;
          const bundleProductName = document.querySelector('product-info > h1').textContent.trim();
          formData.items.push({
            id: bundleProductId,
            quantity: 1,
            properties: {
              '_added_from_page': `added from ${bundleProductName} page`
            }
          });
          });
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData?.items[0]?.id,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              if (this.isFbt) {
                console.log('Fbt cart updated', response);
                // Show existing toast notification and update product details
                const toastElement = document.getElementById('fbt-toast');
                if (toastElement) {
                  // Show the toast by removing hidden class
                  toastElement.classList.remove('hidden');

                  // Update product details in toast
                  if (response.items && response.items.length > 0) {
                    const product = response.items[0];

                    // Update product title
                    const titleElement = document.getElementById('toast-product-label');
                    if (titleElement) titleElement.textContent = product.product_title;

                    // Update product image
                    const imageElement = document.getElementById('toast-product-preview');
                    if (imageElement && product.featured_image) {
                      imageElement.src = product.featured_image.url;
                      imageElement.alt = product.product_title;
                    }

                    // Update variant details
                    const variantElement = document.getElementById('toast-product-variant');
                    if (variantElement && product.options_with_values) {
                      const variantText = product.options_with_values
                        .map(option => `${option.name}: ${option.value}`)
                        .join(', ');
                      variantElement.textContent = variantText;
                    }

                    // Update price
                    const priceElement = document.getElementById('toast-product-price');
                    if (priceElement) {
                      const formattedPrice = new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD'
                      }).format(product.price / 100);
                      priceElement.textContent = formattedPrice;
                    }
                  }

                  // Add click handler for close button if it exists
                  document.getElementById('toast-close')?.addEventListener('click', () => {
                    toastElement.classList.add('hidden');
                  });

                  // Auto hide after 5 seconds
                  setTimeout(() => {
                    toastElement.classList.add('hidden');
                  }, 5000);
                }
              } else {
                window.location = window.routes.cart_url;
              }
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.id,
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            if (window.newrelic) {
              newrelic.noticeError(e, {
                action: 'AddToCart',
                type: 'error',
                message: e.message,
                productId: formData?.items[0]?.id || 'unknown'
              });
            }
            console.error('Cart Error:', e); // Optional: Log to console
          })
          .finally(() => {
            this.submitButton.classList.add('hidden');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        if ( !errorMessage?.email ) {
          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        }

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
